export default "__VITE_ASSET__DwJkg5ge__"